var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baseInfoManage" },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            inline: "",
            "label-width": "130px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.areaGroupIdName"),
                        prop: "upIdList"
                      }
                    },
                    [
                      _c("el-cascader", {
                        staticClass: "form-item-width",
                        attrs: {
                          clearable: "",
                          options: _vm.options,
                          props: _vm.propstree,
                          disabled: _vm.keyValue > 0,
                          "change-on-select": ""
                        },
                        model: {
                          value: _vm.childData.upIdList,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "upIdList", $$v)
                          },
                          expression: "childData.upIdList"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.precincGrouptName"),
                        prop: "areaGroupName"
                      }
                    },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.childData.areaGroupName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "areaGroupName", $$v)
                          },
                          expression: "childData.areaGroupName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.precinctAddr"),
                        prop: "areaGroupAddr"
                      }
                    },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: {
                          clearable: "",
                          maxlength: "100",
                          type: "textarea",
                          placeholder: "请输入地址",
                          autosize: { minRows: 3, maxRows: 3 }
                        },
                        model: {
                          value: _vm.childData.areaGroupAddr,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "areaGroupAddr", $$v)
                          },
                          expression: "childData.areaGroupAddr"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.remark") } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: {
                          clearable: "",
                          maxlength: "100",
                          type: "textarea",
                          placeholder: "请输入备注",
                          autosize: { minRows: 3, maxRows: 3 }
                        },
                        model: {
                          value: _vm.childData.areaGroupRemark,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "areaGroupRemark", $$v)
                          },
                          expression: "childData.areaGroupRemark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }